
interface HeaderProps {
  isScrolled: boolean;
}

export default function Header({ isScrolled }: HeaderProps) {
  const scrollToWaitlist = () => {
    const element = document.getElementById('waitlist');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md py-4' : 'bg-transparent py-6'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img 
            src="https://static.readdy.ai/image/cb419a93222bfd6610832c3481bbaa16/c3691d6cbb39295a29c34cdb741ff2aa.png" 
            alt="CleanerConnect Logo" 
            className="w-20 h-20 object-contain"
          />
          <span className="text-2xl font-bold text-teal-900">CleanerConnect</span>
        </div>

        <button
          onClick={scrollToWaitlist}
          className="bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
        >
          Join the Waitlist
        </button>
      </div>
    </header>
  );
}
